module.exports = __webpack_public_path__ + "img/mainimg.2c28cd93.jpg";